/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
'use strict';

/**
 * Filter module related to files.
 */
angular
  .module('filters.file', [])
  .constant('EXT_TO_CLS', {
    doc: 'sca-icon-attachment-worddoc',
    docm: 'sca-icon-attachment-worddoc',
    docx: 'sca-icon-attachment-worddoc',
    dot: 'sca-icon-attachment-worddoc',
    dotm: 'sca-icon-attachment-worddoc',
    dotx: 'sca-icon-attachment-worddoc',
    default: 'sca-icon-attachment-other',
    gdoc: 'sca-icon-attachment-gdoc',
    gsheet: 'sca-icon-attachment-gsheet',
    link: 'sca-icon-attachment-link',
    html: 'sca-icon-attachment-html',
    img: 'sca-icon-attachment-img',
    pages: 'sca-icon-attachment-pages',
    pdf: 'sca-icon-attachment-pdf',
    ppsm: 'sca-icon-attachment-ppt',
    ppsx: 'sca-icon-attachment-ppt',
    potm: 'sca-icon-attachment-ppt',
    ppt: 'sca-icon-attachment-ppt',
    pptm: 'sca-icon-attachment-ppt',
    pptx: 'sca-icon-attachment-ppt',
    rtf: 'sca-icon-attachment-rtf',
    txt: 'sca-icon-attachment-txt',
    zip: 'sca-icon-attachment-zip'
  })
  /**
   * Based on the passed file extension return a class for an icon for the file.
   *
   * @params {String} fileName - The filename.
   * @returns {String} - A css class that will display an icon.
   */
  .filter('fileNameToCls', function (EXT_TO_CLS) {
    return function (fileName) {
      var cls = EXT_TO_CLS.default,
        indexOfPeriod = fileName ? fileName.lastIndexOf('.') : undefined,
        ext;
      if (fileName && indexOfPeriod !== -1 && indexOfPeriod !== fileName.length) {
        ext = fileName.substring(indexOfPeriod + 1);
        if (EXT_TO_CLS[ext]) {
          cls = EXT_TO_CLS[ext];
        }
      }
      return cls;
    };
  });
